import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var getExtensionManifest = function getExtensionManifest(_ref) {
  var key = _ref.key,
    icons = _ref.icons,
    parameters = _ref.parameters,
    update = _ref.update,
    render = _ref.render,
    title = _ref.title,
    type = _ref.type,
    description = _ref.description,
    source = _ref.source,
    _ref$nodeType = _ref.nodeType,
    nodeType = _ref$nodeType === void 0 ? 'extension' : _ref$nodeType,
    quickInsertAction = _ref.quickInsertAction,
    setUpsellModalSource = _ref.setUpsellModalSource,
    additionalModuleNodeProps = _ref.additionalModuleNodeProps;
  return {
    title: title,
    type: type,
    key: key,
    description: description,
    icons: icons,
    modules: {
      quickInsert: setUpsellModalSource ? [{
        key: 'quick-insert',
        action: function () {
          var _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", setUpsellModalSource(source));
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function action() {
            return _action.apply(this, arguments);
          }
          return action;
        }()
      }] : [{
        key: 'quick-insert',
        action: quickInsertAction || {
          type: 'node',
          key: 'default',
          parameters: parameters
        }
      }],
      nodes: {
        default: _objectSpread({
          type: nodeType,
          render: render,
          update: update
        }, additionalModuleNodeProps)
      }
    }
  };
};